import { render, staticRenderFns } from "./buyGoods.vue?vue&type=template&id=375c8554&scoped=true&"
import script from "./buyGoods.vue?vue&type=script&lang=js&"
export * from "./buyGoods.vue?vue&type=script&lang=js&"
import style0 from "./buyGoods.vue?vue&type=style&index=0&id=375c8554&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375c8554",
  null
  
)

export default component.exports